
import store from "@/store/store";

import Vue from "vue";
import { state } from "@/store/state.js";

export function clone(sth) {
  return JSON.parse(JSON.stringify(sth));
}
//全局变量初始化加载
export function globalInit(obj) {
  for (let key in obj) {
    Vue.prototype[`$${key}`] = obj[key];
  }
}

export function getInit() {
  let _obj = {};
  for (let x in state) {
      _obj[`get${x.substr(0, 1).toUpperCase()}${x.substr(1)}`] = (state) => {
        return state[x];
      };
  }  
  return _obj;
}
export function commit(a, b) {
  return store.commit(a, b);
}

export function changeInit() {
  let _obj = {};
  for (let x in state) {
    // console.log(state)
      _obj[`change${x.substr(0, 1).toUpperCase()}${x.substr(1)}`] = (
          state,
          n
      ) => {
          state[x] = n;
      };
  }
  return _obj;
}

//获取今天的时间
export function GetToday() {
  var date = new Date();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if ((month + "").length == 1)
      month = "0" + month;
  if ((day + "").length == 1)
      day = "0" + day;
  return date.getFullYear() + "-" + month + "-" + day;
}